import { render, staticRenderFns } from "./GrantsConstraintsPlansSlidDetailsInfo.vue?vue&type=template&id=6628624a&"
import script from "./GrantsConstraintsPlansSlidDetailsInfo.vue?vue&type=script&lang=js&"
export * from "./GrantsConstraintsPlansSlidDetailsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports